import { usePayStatementItemStore } from '../store/pay-statement-store';

export function useLabels() {
  const { labels, setLabel } = usePayStatementItemStore();

  return { labels, setLabel };
}
